/**
 * Banned appraisers registry API — wraps the `/loan-processing/banned-appraisers`
 * router (frontend_documentation/banned-appraisers.md). A GLOBAL admin list of
 * appraisers the desk won't accept. Each record is a LoanContact
 * (loanRole "Appraiser" + appraiserLicenseNumber) plus ban metadata, deduped
 * server-side by registryKey (license, else name/company slug).
 *
 * Add/Edit bodies are a LoanContact shape; do NOT send `_id`, `registryKey`,
 * `normalizedLicenseNumber`, or `createdAt` (all server-derived). Add upserts on
 * the license; Edit is partial (changed fields only).
 */
import { losHttp } from "../lib/losHttp";

const BASE = "/loan-processing/banned-appraisers";

export const losBannedAppraisersApi = {
  // GET /loan-processing/banned-appraisers → BannedAppraiser[] (sorted by name)
  list: () =>
    losHttp.get(BASE).then((r) => r.data?.bannedAppraisers || []),

  // GET /loan-processing/banned-appraisers/check?license= → { banned, match }
  check: (license) =>
    losHttp
      .get(`${BASE}/check`, { params: { license } })
      .then((r) => r.data),

  // POST /loan-processing/banned-appraisers → 201 the created/updated record
  add: (body) => losHttp.post(BASE, body).then((r) => r.data),

  // PUT /loan-processing/banned-appraisers/{appraiserId} → the updated record
  edit: (appraiserId, body) =>
    losHttp.put(`${BASE}/${appraiserId}`, body).then((r) => r.data),

  // DELETE /loan-processing/banned-appraisers/{appraiserId} → { removed, id }
  remove: (appraiserId) =>
    losHttp.delete(`${BASE}/${appraiserId}`).then((r) => r.data),
};

export default losBannedAppraisersApi;
